<div class="demo-container">
  <div class="title">SignalR</div>

  <input
    [(ngModel)]="broadcastMessage"
    type="text"
    placeholder="Enter broadcast message"
    class="form-control mb-2"
    data-testid="signalr-test-broadcast-message">

  <div class="d-flex align-items-center">
    <input
      [(ngModel)]="disableTimeout"
      id="disable-toast-timeout"
      type="checkbox"
      class="mx-1 my-1"
      data-testid="signalr-test-disable-toastr-timeout-checkbox">
    <label for="disable-toast-timeout" class="mx-1 my-1">Disable Toastr Timeout</label>
  </div>

  <div class="d-flex align-items-center mb-2">
    <div class="mr-2">Broadcast to: </div>

    <button
      type="button"
      class="btn btn-primary btn-sm mr-2"
      (click)="sendMessageToDevelopers()"
      data-testid="signalr-test-developers">
      Developers
    </button>

    <button
      type="button"
      class="btn btn-warning btn-sm mr-2"
      (click)="sendMessageToAllUsers()"
      data-testid="signalr-test-all-users">
      All Users
    </button>
  </div>

  <button
    type="button"
    class="btn btn-primary btn-sm"
    (click)="reconnectSignalR()"
    data-testid="signalr-test-reconnect-signal-r">
    Reconnect SignalR
  </button>
</div>




// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/signalr-test/signalr-test.component.html